import { createFileRoute } from "@tanstack/react-router";
import { OutdoorServicePage } from "./services_.outdoor";

export const Route = createFileRoute("/services_/outdoor-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "Outdoor Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "High-Impact OOH & Transit Advertising Solutions.",
      },
    ],
  }),
  component: OutdoorServicePage,
});
